import { useState, useEffect } from 'react';
import holidayService from '../service/holidayService';
import useDebounce from '../../branchLocator/hooks/useDebounce';

export const useListingSuggestCities = props => {
  const [suggestedCities, setSuggestedCities] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  useEffect(() => {
    if (debouncedSearchTerm?.length > 1) {
      const body = {
        searchTerm: debouncedSearchTerm,
        branch: 'DOM',
      };
      if (props?.contextSearch) body.context = 'Search';
      (async () => {
        const { data, error } = await holidayService.post(props.url, body);
        setSuggestedCities(transformData(data.searchDestinationList));
      })();
    }
  }, [debouncedSearchTerm]);

  const transformData = suggestedCities => {
    let options = [];
    if (suggestedCities && suggestedCities.length > 0) {
      options = suggestedCities.map(c => ({ value: c.name, label: c.name, name: c.name, city: c }));
    }
    return options;
  };
  return [suggestedCities, setSearchTerm, setSuggestedCities];
};
